export const selectPricingCustomFields = ({ pricing }) => pricing.customFields;
